module.exports = __webpack_public_path__ + "media/3.dd656b21.mp3";